import { useEffect, useState } from 'react';

/** The preview draws at most this many frames a second (the files are 30 fps; the motion is slow). */
const PREVIEW_FPS = 30;

function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;
}

/**
 * The frame of a loop of `loopFrames` frames at 30 fps, from the page clock, while `playing`.
 * With reduced motion, or when not playing, it stays on frame 0 (the cover).
 */
export function useLoopFrame(loopFrames: number, playing: boolean): number {
  const [frame, setFrame] = useState(0);
  useEffect(() => {
    if (!playing || loopFrames <= 0 || prefersReducedMotion() || typeof requestAnimationFrame === 'undefined') {
      setFrame(0);
      return undefined;
    }
    const start = performance.now();
    let handle = 0;
    const tick = (now: number) => {
      setFrame(Math.floor(((now - start) / 1000) * PREVIEW_FPS) % loopFrames);
      handle = requestAnimationFrame(tick);
    };
    handle = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(handle);
  }, [loopFrames, playing]);
  return frame;
}
